import type { VoicePage } from "@/content/voicePages";

export type CurrentRecordingSummary = {
  page_number: string;
  duration_seconds: number;
  created_at: string;
  is_current: boolean;
};

export type VoiceLibraryItem = VoicePage & {
  recording: CurrentRecordingSummary | null;
};

export function buildVoiceLibrary(
  pages: VoicePage[],
  recordings: CurrentRecordingSummary[],
): VoiceLibraryItem[] {
  const currentByPage = new Map<string, CurrentRecordingSummary>();
  for (const recording of recordings) {
    if (!recording.is_current) continue;
    const previous = currentByPage.get(recording.page_number);
    if (!previous || Date.parse(recording.created_at) > Date.parse(previous.created_at)) {
      currentByPage.set(recording.page_number, recording);
    }
  }

  return pages.map((page) => ({
    ...page,
    recording: currentByPage.get(page.number) ?? null,
  }));
}
